// WallPost represents a post on the sponsors wall.
// Maps snake_case fields from backend into camelCase used in frontend.
export default class WallPost {
  constructor(data = {}) {
    const d = data || {};
    this.id = d.id ?? null;
    this.title = d.title ?? '';
    this.publicText = d.public_text ?? d.publicText ?? '';
    this.hiddenText = d.hidden_text ?? d.hiddenText ?? '';
    this.publishTime = d.publish_time ?? d.publishTime ?? null;
    this.published = d.published ?? true;
    this.isDraft = d.is_draft ?? d.isDraft ?? false;
    this.attachmentUrl = d.attachment_url ?? d.attachmentUrl ?? null;
    this.publicAttachment = d.public_attachment ?? d.publicAttachment ?? null;
    this.attachmentURLKind = d.attachment_url_kind ?? d.attachmentURLKind ?? null;
    this.imageUrl = d.image_url ?? d.imageUrl ?? null;
    this.imageForSubscribersOnly = !!(d.image_for_subscribers_only ?? d.imageForSubscribersOnly ?? false);
    this.imageRemoved = !!(d.image_removed ?? d.imageRemoved ?? false);
    // Normalize levels array: can be array of ids or objects with id/external_id
    this.levelIDs = [];
    const levels = Array.isArray(d.levels) ? d.levels : [];
    for (const lvl of levels) {
      if (typeof lvl === 'number') {
        this.levelIDs.push(lvl);
      } else if (lvl && typeof lvl === 'object') {
        if (lvl.id != null) this.levelIDs.push(lvl.id);
        if (lvl.ID != null) this.levelIDs.push(lvl.ID);
      }
    }
    // Backend may explicitly tell that hidden text/link were stripped
    this.hiddenTextRemoved = !!(d.hidden_text_removed ?? d.hiddenTextRemoved ?? false);
    this.attachmentURLRemoved = !!(d.attachment_url_removed ?? d.attachmentURLRemoved ?? false);
    this.locked = !!(d.locked ?? d.Locked ?? false);
    this.expandedByDefault = !!(d.expanded_by_default ?? d.expandedByDefault ?? false);
    this.pinnedToTop = !!(d.pinned_to_top ?? d.pinnedToTop ?? false);
    // Convenience flag (if not provided explicitly) — post has hidden content
    const imageLocked = this.imageForSubscribersOnly && (this.imageUrl || this.imageRemoved);
    this.subscriberOnly = !!(d.subscriber_only ?? d.subscriberOnly ?? (this.hiddenText || this.attachmentUrl || imageLocked));
  }
  clone() {
    return new WallPost({
      id: this.id,
      title: this.title,
      public_text: this.publicText,
      hidden_text: this.hiddenText,
      publish_time: this.publishTime,
      published: this.published,
      is_draft: this.isDraft,
      attachment_url: this.attachmentUrl,
      public_attachment: this.publicAttachment,
      attachment_url_kind: this.attachmentURLKind,
      image_url: this.imageUrl,
      image_for_subscribers_only: this.imageForSubscribersOnly,
      image_removed: this.imageRemoved,
      levels: [...this.levelIDs],
      hidden_text_removed: this.hiddenTextRemoved,
      attachment_url_removed: this.attachmentURLRemoved,
      locked: this.locked,
      subscriber_only: this.subscriberOnly,
      expanded_by_default: this.expandedByDefault,
      pinned_to_top: this.pinnedToTop,
    });
  }
}
